// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uk-0";
export var checkoutRateBadgeLink = "_uk-1";